import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import SimpleBar from 'simplebar';
import { FuelCardService } from '../../services/fuel-card.service';
import { SaveParsedDataResponse } from '../../models/save-parsed-data-response';

@Component({
  standalone: false,
  selector: 'app-fuel-card-notification',
  templateUrl: './fuel-card-notification.component.html',
  styleUrls: [ './fuel-card-notification.component.scss' ]
})
export class FuelCardNotificationComponent implements OnInit {

  @Input()
  stats!: any;

  @Input()
  error!: any;

  constructor(
    public activeModal: MatDialogRef<FuelCardNotificationComponent>,
    private _fuelCardService: FuelCardService,
    private _modalService: MatDialog
  ) {
  }

  public ngOnInit(): void {
    const scrollBar: SimpleBar = new SimpleBar(document.querySelector('.scroll'));
  }

  public accept(): void {
    if (this.stats && this.stats.parsedDataKey) {
      this._fuelCardService.saveParsedFuelCard({ ParsedDataKey: this.stats.parsedDataKey })
        .pipe(first())
        .subscribe(
          (result: SaveParsedDataResponse) => this.activeModal.close(result),
          (error: any) => this.openErrorModal(error.error['data'])
        );
    }
  }

  private openErrorModal(error: any): void {
    const modalRef: MatDialogRef<FuelCardNotificationComponent> = this._modalService.open(FuelCardNotificationComponent, {});
    modalRef.componentInstance.error = error;
  }
}
